import config from '../config.json';

export const BACKEND_URL = config.backend_url;
export const FRONTEND_URL = config.frontend_url;

export default config; 